import React from 'react';

import styled from '@emotion/styled';
import { Checkbox as ACheckbox, CheckboxProps } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';

const { Group: ACheckboxGroup } = ACheckbox;

export interface ICheckboxParams extends CheckboxProps {}

export interface ICheckboxGroupParams extends CheckboxGroupProps {}

export const Checkbox = styled(ACheckbox)`
  /* 요소시작 : &label.ant-checkbox-wrapper */
  /* default */
  .ant-checkbox {
    .ant-checkbox-inner {
      border-radius: 1px;
    }
  }
  .ant-checkbox + span {
    padding-left: 6px;
  }
  /* All */
  .ant-checkbox.ant-checkbox-indeterminate {
    .ant-checkbox-inner::after {
      height: 2px;
      background-color: ${({ theme }) => theme.link2};
    }
  }
  /* checked */
  .ant-checkbox.ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: ${({ theme }) => theme.link2};
      border-color: ${({ theme }) => theme.link2};
    }
    .ant-checkbox-inner::after {
      border: 1.8px solid ${({ theme }) => theme.gray1};
      border-top: 0;
      border-left: 0;
      top: 6px;
    }
  }
  /* disabled */
  .ant-checkbox.ant-checkbox-disabled {
    .ant-checkbox-inner {
      background-color: ${({ theme }) => theme.gray3};
      border-color: ${({ theme }) => theme.gray4} !important;
    }
  }
  .ant-checkbox.ant-checkbox-disabled + span {
    color: ${({ theme }) => theme.gray4};
  }
  /* All & disabled */
  .ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled {
    .ant-checkbox-inner::after {
      background-color: ${({ theme }) => theme.gray5};
    }
  }
`;

const StyledCheckboxGroup = styled(ACheckboxGroup)`
  width: 100%;
  border: 0;
`;

export const CheckboxGroup = ({ children, ...rest }: ICheckboxGroupParams) => (
  <StyledCheckboxGroup {...rest}>{children}</StyledCheckboxGroup>
);
